module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Book-Of-Love-The.559756d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Book-Of-Love-The.jpg
// module id = ibtY
// module chunks = 0